import * as React from "react";
import styled, { css, keyframes } from "../../../styled/index";
import lighten from "polished/lib/color/lighten";
import { shadeAlternate } from "../../../styled/helpers";
const animation = keyframes `
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const RotateSpin = styled("span") `
  display: block;
  animation: ${(props) => css `${animation} ${0.6 || props.duration}s infinite linear`};
  border: ${(props) => `1.1em solid ${props.color ? shadeAlternate(0.2, props.color || props.theme.colors.primary) : lighten(0.2, props.theme.colors.primary)}`};
  border-left: ${(props) => `1.1em solid ${props.color || props.theme.colors.primary}`};
  border-radius: 50%;
  font-size: ${(props) => `${props.size || 5}px`};
  height: 10em;
  margin: 0 auto;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
  width: 10em;
  &:after {
    border-radius: 50%;
    height: 10em;
    width: 10em;
  }
`;
export const RotateLoader = (props) => (React.createElement(RotateSpin, Object.assign({}, props)));
//# sourceMappingURL=index.js.map